import { alpha } from '@mui/material/styles';

import { theme } from '@/design-system';

const blue = '#3B82F6';
const purple = '#8B5CF6';
const teal = '#14B8A6';
const green = '#22C55E';
const yellow = '#EAB308';
const amber = '#EF9F27';
const brown = '#BA7517';
const neutralMuted = '#737373';

export const pipelineColors = {
  surfaceAlt: theme.colors.background.raised,
  white: '#FFFFFF',
  neutralMuted,
  badgeSurface: '#2A2A2A',
  badgeDark: theme.colors.border.default,
  blue,
  lightBlue: theme.colors.info.solid,
  lightYellow: theme.colors.warning.solid,
  purple,
  teal,
  green,
  yellow,
  amber,
  brown,
  purpleSoft: alpha(purple, 0.13),
  badgeBlueSurface: alpha(blue, 0.15),
  badgeAmberSurface: 'rgba(255, 220, 78, 0.2)',
  badgePurpleSurface: alpha(purple, 0.13),
  badgeGreenSurface: alpha(green, 0.15),
  badgeRedSurface: alpha(theme.colors.error.solid, 0.15),
  cardLightBlueSurface: alpha(theme.colors.info.solid, 0.05),
  cardLightBlueBorder: alpha(theme.colors.info.solid, 0.3),
  activeColumnSurface: alpha(blue, 0.03),
  activeColumnBorder: alpha(blue, 0.06),
  amberColumnSurface: alpha(theme.colors.warning.solid, 0.05),
  terminalColumnSurface: alpha(neutralMuted, 0.05),
  terminalColumnBorder: alpha(neutralMuted, 0.06),
  cardAmberBorder: alpha(amber, 0.3),
} as const;
